export default "__VITE_ASSET__j5oEh$ik__"